import { React, useEffect } from 'react';
import AOS from 'aos';
import disc from '../../Assets/disc.svg';
import star from '../../Assets/star.svg';
import group from '../../Assets/group.svg';
import mailMan from '../../Assets/mailMan.svg';
import ModalClick from './ModalClick';

const BusinessSupportCmpt = () => {
	useEffect(() => {
		AOS.init({ duration: 1500 });
	}, []);
	const rows = {
		row1: {
			header: 'Logistic License Consultation Sevice',
			text: 'We support Logistics companies through the process of obtaining their operating license with NIPOST. The following are the license requirements:',
			list: [
				'The Certificate of Incorporation and Memorandum/Articles of Association of the applicant company',
				'The Business plan, Company profile and Operations manual of the company (the operations manual in particular must involve consulting a lawyer to advise you fully on the provisions of the Regulations)',
				'A Goods-in-Transit policy of the applicant company',
				'A Tax clearance certificate',
				'Evidence/Proof of Share Capital being allotted and subscribed to',
				'A filled application form P306 along with a non-refundable license application fee of 20,000Naira payable to the Treasury Single Account (TSA)',
				'Evidence of storage and warehousing facilities on inspection',
				'Office location details',
				'Evidence of Compliance regarding Expatriate quota Regulations where Non-Nigerians are to be hired by the applicant company',
				'Evidence of payment of licensing fees for a particular category',
			],
			id: 1,
			btn: 'Request Service',
		},
		row2: {
			header: 'Logistic Insurance Sevice',
			text: 'Our logistic business partners can seamlessly purchase their insurance covers on logistat. The following insurance covers are exposed on logistat',
			list: [
				'Goods in Transit (GIT) insurance',
				'3rd party or comprehensive vehicle/motorcycle insurance',
				'Personal accident insurance cover',
			],
			id: 2,
			btn: 'Request Service',
		},
	};
	const row = (row) => {
		const textStyle = {
			fontSize: '0.9rem',
		};
		return (
			<>
				<div className='h5 fw-bold mb-2'>
					<span style={{ marginRight: '1rem' }}>
						<img className='my-auto' src={disc} alt='disc' />
					</span>
					{row.header}
				</div>
				<div className='fw-semibold my-3' style={textStyle}>
					{row.text}
				</div>
				{row.list.map((line) => {
					return (
						<div className='my-2' style={textStyle}>
							<span style={{ marginRight: '1rem' }}>
								<img
									className='my-auto'
									style={{ width: '0.6rem' }}
									src={star}
									alt='disc'
								/>
							</span>
							{line}
						</div>
					);
				})}
				<span
					className='btn btn-md text-white my-4 py-3 px-4 border-0'
					style={{ background: 'rgba(40, 182, 114, 1)' }}
				>
					<ModalClick text='Request Service' />
				</span>
			</>
		);
	};
	return (
		<div className='container mt-5' style={{ ocerflow: 'hidden' }}>
			<div className='pt-5 mb-3 h2 fw-bold'>Business Support Service</div>
			<div className='row'>
				<div data-aos='fade-right' className='col-12 col-lg-6'>
					{row(rows.row1)}
				</div>
				<div data-aos='fade-left' className='col-12 col-lg-6 text-center'>
					<img
						src={group}
						className='img-fluid'
						style={{ maxWidth: '25rem' }}
						alt='group'
					/>
				</div>
			</div>

			<div className='container'>
				<div className='d-flex flex-column-reverse gap-5 my-5 flex-lg-row text-center'>
					<div className='col-12 col-lg-6'>
						<div
							className='text-center pt-0 pt-md-2 pt-lg-5 mb-4'
							data-aos='fade-left'
						>
							<img
								src={mailMan}
								style={{ maxHeight: '22rem' }}
								alt='ThumbsUp'
								className='img-fluid h-100 w-100'
							/>
						</div>
					</div>
					<div data-aos='fade-right' className='col-12 col-lg-6'>
						<div className='pt-0 pt-lg-3 my-0 my-lg-5 text-start px-4'>
							{row(rows.row2)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BusinessSupportCmpt;
